// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X1Yh","questions":"styles_questions__3oSEl","footer":"styles_footer__2b8vO"};